<template>
    <div id="app"
         class="layout"
         :class="{ '_pages-active': isProfilePagesActive }"
    >
        <Container without-padding>
            <TheHeader />
        </Container>

        <main class="main">
            <slot />
        </main>

        <TheFooter v-if="isProfilePagesActive" />

        <TheModal />

        <TheOverlay />

        <Widget />
    </div>
</template>

<script setup>
    import Container from '~/src/shared/components/common/Container/Container.vue'
    import { useOverlayStore } from '~/src/shared/pinia/useOverlayStore'
    import TheFooter from '~/src/widgets/footer/TheFooter.vue'
    import TheHeader from '~/src/widgets/header/TheHeader.vue'
    import TheModal from '~/src/widgets/modal/TheModal.vue'
    import TheOverlay from '~/src/widgets/overlay/TheOverlay.vue'
    import Widget from '~/src/widgets/widget/Widget.vue'

    // const route = useRoute()

    const { hideOverlay } = useOverlayStore()

    onBeforeUnmount(() => {
        hideOverlay()
    })

    const route = useRoute()

    const EXCLUDED_FOOTER_LIST = ['profile', 'profile-edit', 'profile-notification', 'profile-support', 'profile-tariff']

    const isProfilePagesActive = computed(() => !EXCLUDED_FOOTER_LIST.includes(route.name))
</script>

<style scoped lang="scss">
    .layout {
        display: flex;
        flex-flow: column;
        min-width: 320px;
        min-height: 100vh;
        background-color: var(--indigo-100);

        :deep(.header) {
            --header-background-color: var(--white);
        }
    }

    .main {
        position: relative;
        flex-grow: 1;
    }
</style>
